const headerHeight = '55px';
const navWidth = '70px';
const navHeight = '56px';

export {
  headerHeight,
  navHeight,
  navWidth,
};
